import React from 'react';
import WorkTimeline from '../../components/organisms/work-timeline';
import Page from '../page';

const ResumePage = () => {
    return (
        <Page>
            <section>
                <WorkTimeline />
            </section>
        </Page>
    )
}

export default ResumePage;